import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";

function useAddendumAttachmentFile(attachmentId: string, enabled = true) {
  return useAxiosQuery(
    ["addendumAttachmentFile", { attachmentId }],
    () =>
      axiosChartInstance.get<Blob>(
        `v1/addendum/attachments/${attachmentId}/file`,
        { responseType: "blob" }
      ),
    { enabled: enabled && !!attachmentId, staleTime: Infinity }
  );
}

export { useAddendumAttachmentFile };
